import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import Expander from '@helsenorge/designsystem-react/components/Expander';
import { PortableText } from '../../richtext';
import { PortableTextContext } from '../../richtext/portable-text-content';
const EkspanderendeTekstBlock = ({ title, mainContent, }) => {
    const components = useContext(PortableTextContext)?.components;
    if (title.length === 0 || mainContent.length === 0) {
        return null;
    }
    return (_jsx(Expander, { title: title, noNestedLine: true, renderChildrenWhenClosed: true, children: _jsx(PortableText, { value: mainContent, components: components }) }));
};
export default EkspanderendeTekstBlock;
